import Vue from "vue";
import VueRouter from "vue-router";

/**
 * Capturador
 */
import NavbarCap from "../components/Capturador/NavbarCap.vue";
import NewMemberCap from "../views/Capturador/NewMemberCap.vue";
import ListMembers from "../views/Capturador/ListMembers.vue";
import ProfileMemberCap from "../views/Capturador/ProfileMemberCap.vue";
import LoginCap from "../views/Capturador/LoginCap.vue";
import Certificates from "../views/Capturador/CertificatesCap.vue";
import FoliosCap from "../views/Capturador/FoliosCap.vue";
import FinancingPayments from "../components/Capturador/FinancingPayments.vue";
import ProfileMemberRouter from "@/views/Capturador/ProfileMemberRouter.vue";
// import DocumensoEmbed from "@/views/Documenso/DocumensoEmbed.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    redirect: "/logincap",
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/logincap",
    name: "LoginCap",
    component: LoginCap,
    meta: {
      isAuth: true,
    },
  },
  {
    path: "/navbar-cap",
    name: "navbar-cap",
    component: NavbarCap,
    children: [
      {
        path: "/new-member",
        name: "NewMemberCap",
        component: NewMemberCap,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/list-members",
        name: "ListMembers",
        component: ListMembers,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/profile-member",
        name: "ProfileMemberCap",
        // component: ProfileMemberCap,
        component: ProfileMemberRouter,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/guests",
        name: "Guests",
        component: Certificates,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/folios",
        name: "FoliosCap",
        component: FoliosCap,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "/financing-payments",
        name: "FinancingPayments",
        component: FinancingPayments,
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // {
  //   path: "/documenso/:token",
  //   name: "DocumensoEmbed",
  //   component: DocumensoEmbed,
  //   meta: {
  //     isAuth: false,
  //   },
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("user")) {
      next();
      return;
    }
    next("/");
  } else {
    next();
  }

  if (to.matched.some((record) => record.meta.isAuth)) {
    if (localStorage.getItem("user")) {
      next("/new-member");
      return;
    }
    next();
  } else {
    next();
  }
});

export default router;
